import React, { useState, useEffect } from "react";
import { Modal, Table, Input, Checkbox, Row, Col, Button, Divider } from "antd";
import { PickupIconEstimate } from "../../common/CustomIcon";
import TableComponent from "./Table_v2";
import { saveInvoice } from "../../api/Billing";
import { alertMessage } from "../../common/Common";
import { renderAlertMessage } from "../../helpers/common";
import I18n from "../../common/I18n";
import { createOrderQuoteAmount } from "../../api/OrdersApi";
import { renderNotification } from "../../components/orders/OrderTypeIcons";

const EditEstimateModal = ({ currenOrder, isModalVisible, handleCancel, orderid, dataSource, existingData, currentOrg, recalculate = () => { } }) => {
  const [tableData, setTableData] = useState([]);
  const [initialData, setInitialData] = useState([]);
  useEffect(() => {
    if (isModalVisible) {
      setTableData([...dataSource]);
      setInitialData(dataSource);
    }
  }, [isModalVisible, dataSource]);
  
  const handleTableChange = (value, key, columnKey) => {
    const updatedData = tableData.map((item) => {
      if (item.key === key) {
        return { ...item, [columnKey]: value };
      }
      return item;
    });
    setTableData(updatedData);
  };
  const handleReset = () => {
    setTableData([...initialData]);
  };

  const handleQuoteUpdate = () => {
    const order_id = orderid;
    const payload = {
      order_id,
      organization_id: currentOrg.id,
      org_id: currentOrg.id,
      // is_for_invoice_quote: true,
      order_quotations: tableData.map((item) => ({
        customer_order_id: order_id,
        amount: item.amount || "0",
        configurations: {
          include_fuel_surcharge: String(item.includesFuel || false),
        },
        location_id: item.location_id || "",
      })),
    };
    // saveInvoice(payload)
    createOrderQuoteAmount(payload)
    .then((result) => {
      if (result.success) {
          renderNotification("Quote is Updated Successfully");
          handleCancel()
          recalculate(orderid)
        } else if (result.errors) {
          renderAlertMessage(result.errors);
        }
      });
  };

  const calculateTotals = () => {
    const totalDistance = tableData.reduce((acc, item) => acc + (parseFloat(item.distance) || 0), 0);
    const totalRate = tableData.reduce((acc, item) => acc + (parseFloat(item.amount) || 0), 0);

    return {
      totalDistance: totalDistance.toFixed(2),
      totalRate: totalRate.toFixed(2),
    };
  };

  const { totalDistance, totalRate } = calculateTotals();

  const columns = [
    {
      title: "Stop",
      dataIndex: "stop",
      key: "stop",
      width: 100,
      align: "left",
      render: (text) => {
        return (
          <div>
            {text === "PICKUP" ? (
              <span style={{ display: 'flex', alignItems: 'center' }}>
                <PickupIconEstimate />  &nbsp; Pickup
              </span>
            ) : text === "DELIVERY" ? (
              <span style={{ display: 'flex', alignItems: 'center' }}>
                <DeliveryIconEstimate /> &nbsp; Delivery
              </span>
            ) : (
              text
            )}
          </div>
        )
      },
    },
    {
      title: "Distance",
      dataIndex: "distance",
      key: "distance",
      width: 150,
      align: "center",
      render: (text, record) => (
        <Input
          value={text}
          disabled 
          onKeyPress={(e) => {
            if (!/^\d*\.?\d*$/.test(e.target.value + e.key)) {
              e.preventDefault();
            }
          }}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d*\.?\d*$/.test(value)) {
              handleTableChange(value, record.key, "amount");
            }
            handleTableChange(value, record.key, "distance")}}
          suffix="mi"
        />
      ),
    },
    {
      title: "Rate",
      dataIndex: "amount",
      key: "amount",
      render: (text, record) => (
        <Input
          value={text}
          onKeyPress={(e) => {
            if (!/^\d*\.?\d*$/.test(e.target.value + e.key)) {
              e.preventDefault();
            }
          }}
          onChange={(e) => {
            const value = e.target.value;
            if (/^\d*\.?\d*$/.test(value)) {
              handleTableChange(value, record.key, "amount");
            }
          }}
          prefix="$"
        />
      ),
    },
    {
      title: "Includes Fuel",
      dataIndex: "includesFuel",
      key: "include_fuel_surcharge",
      render: (checked, record) => (
        <Checkbox
          checked={checked}
          onChange={(e) => handleTableChange(e.target.checked, record.key, "includesFuel")}
        />
      ),
    },
  ];

  const footer = () => (
    <>
      <div style={{ background: "#efeff5", padding: "10px 10px" }}>
        <Row style={{ width: "100%" }}>
          <Col
            className="estimateOverrider-2-large"
            span={6}
            style={{ textAlign: "left" }}
          >
            Total
          </Col>
          <Col
            className="estimateOverrider-2-large"
            span={6}
            style={{ textAlign: "center" }}
          >
            {totalDistance} mi
          </Col>
          <Col
            className="estimateOverrider-2-large"
            span={6}
            style={{ textAlign: "center" }}
          >
            $ {totalRate}
          </Col>
          <Col span={6}></Col>
        </Row>
      </div>
    </>
  );

  return (
    <Modal
      title="Edit Quote"
      visible={isModalVisible}
      footer={[
        <Row
          gutter={24}
          justify="space-between"
          align="middle"
          style={{ width: "100%" }}
        >
          <Col span={6}>
            <Button
              key="reset"
              className="medium-btn flat"
              type="link"
              onClick={handleReset}
            >
              Reset to Default
            </Button>
          </Col>
          <Col span={6}></Col>
          <Col span={6} justify="space-between">
            <Button
              key="cancel"
              className="medium-btn flat"
              type="link"
              onClick={handleCancel}
              style={{ marginRight: "16px" }}
            >
              Cancel
            </Button>
          </Col>
          <Col span={6}>
            <Button
              key="update"
              className="medium-btn flat"
              type="link"
              onClick={handleQuoteUpdate}
            >
              Update Quote
            </Button>
          </Col>
        </Row>,
      ]}
      centered
      closable={false}
    >
      <TableComponent
        className="EditEstimateModalClass"
        dataSource={tableData}
        columns={columns}
        pagination={false}
        footer={footer}
      />
    </Modal>
  );
};

export default EditEstimateModal;
